import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from "@angular/router";


import { TH, EN } from './constants/constants'
import { CookieConsentService } from './services/cookie.service';
import { AssetService } from './services/asset.service';

declare var $: any;
declare let gtag: Function;

// // Put the object into storage
// localStorage.setItem('language', JSON.stringify(testObject));
// // Retrieve the object from storage
// var retrievedObject = localStorage.getItem('language');
// console.log('retrievedObject: ', JSON.parse(retrievedObject));

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  language = JSON.parse(JSON.stringify(TH)); //JSON.parse(localStorage.getItem('language'));
  title = 'app';
  popupImage = '';
  popupLink = '';
  isNotPopup: boolean = false
  constructor(private router: Router, private cookieService: CookieConsentService, private _assetService: AssetService,) {
    // this.cookieService.clearConsentCookie();
    const c = this.cookieService.checkGoogleTag();
    // console.log('google tag : ' + c)
    if (c !== '0') {
      // console.log('enable google tag')
      this.router.events.subscribe(event => {
        if (event instanceof NavigationEnd) {
          gtag('config', 'UA-105232690-2', { 'page_path': event.urlAfterRedirects })
          // (<any>window).ga('set', 'page', event.urlAfterRedirects);
          // (<any>window).ga('send', 'pageview');
        }
      });
    }
    this.cookieService.checkCookieConsent();
  }

  ngOnInit() {
    // console.log(sessionStorage.getItem('login'));
    if (sessionStorage.getItem('login') == null) {
      $('#warningModal').modal('show')
    }
    const isPopup = sessionStorage.getItem('popup');
    // popup modal
    if (isPopup !== '1') {
      this._assetService.getPopup().subscribe(response => {
        this.popupImage = response['Result']['Image'];
        this.popupLink = response['Result']['Link'];
        if (this.popupImage === '') {
          return;
        }
        // sessionStorage.setItem('popup', '1');
        $('#popupModal').modal('show');
      });
    }

    // console.log(TH.version);
    // console.log(localStorage.getItem('language'));
    if (localStorage.getItem('language') === null || JSON.parse(localStorage.getItem('language')).version !== TH.version) {
      console.log('update languages');
      localStorage.setItem('language', JSON.stringify(TH));
      localStorage.setItem('language_flag', 'th');
    } else {
      this.language = JSON.parse(localStorage.getItem('language'));
    }
  }

  userDisagree() {
    location.href = 'http://google.com'
  }

  userAgree() {
    $('#warningModal').modal('hide')
    sessionStorage.setItem('login', 'y')
    // $('#alertModal').modal('show')
  }

  userAgreeAlert() {
    $('#alertModal').modal('hide')
    sessionStorage.setItem('login', 'y')
  }

  userclosesum(){
    $('#warningModalForformanceSum').modal('hide');
  }

  notgotopine(){
    $('#onelivetopineModal').modal('hide')
  }
  gotopine(){
    $('#onelivetopineModal').modal('hide')
    window.open('https://oacc.settrade.com/e-open-account/landing?brokerId=514');
  }

  closePopup() {
    $('#popupModal').modal('hide');
    sessionStorage.setItem('popup', '1');
  }
  
  linkPopup() {
    if (this.popupLink !== '') {
      window.open(this.popupLink, '_blank');
    }
    $('#popupModal').modal('hide');
    sessionStorage.setItem('popup', '1');
  }
}

